import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableHomeConfigs from './formGroupLiveApps/tableHomeConfigs';
import tableHomeSpaces from './formGroupLiveApps/tableHomeSpaces';

export default {
  title: 'Spaces',
  attributeName: 'spaces',
  fields: [
     {
      attributeName: 'spaces',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableHomeSpaces,

    },
   
  ],
};
